import React from "react";
import { DfpAd } from "../dfp-ad/";
import "./dfp-ad-horizontal.m.css";

export function DFPAdsHorizontal() {
  return (
    <div styleName="dfp">
      <DfpAd adtype="NH_HP_728x90" />
    </div>
  );
}
